<template>
  <div class="review-item">
    <div class="user ch-flex">
      <img :src="review.user.avatar" alt="">
      <div class="text">
        <h3>{{review.user.nickname}}</h3>
        <div class="stars">
          <span class="iconfont icon-star" v-for="i in review.star" :key="i"></span>
        </div>
      </div>
    </div>
    <div class="review-content">
      {{review.content}}
    </div>
    <div class="review-images">
      <ul>
          <li v-for="(item, index) in review.images"
               @click="showViewer(index, $event)" :key="index">
            <div class="img"
                 :style="`background: url(${item}) center no-repeat;background-size:cover;`">
            </div>
          </li>
      </ul>
    </div>

    <md-image-viewer
            v-model="isViewerShow"
            :list="review.images"
            :has-dots="true"
            :initial-index="viewerIndex">
    </md-image-viewer>
  </div>
</template>

<script>
import {ImageViewer} from 'mand-mobile'
export default {
  name: "review-item",
  components: {
      [ImageViewer.name]: ImageViewer,
  },
  props: ["review"],
  methods: {
      showViewer(index) {
          this.viewerIndex = index;
          this.isViewerShow = true;
      },
  },
    data() {
      return {
          isViewerShow: false,
          viewerIndex: 0,
      }
    },
};
</script>

<style lang="scss" scoped>
  .review-item{
    margin-top: 60px;

    .user {
      img {
        border-radius: 50%;
        height: 70px;
        width: 70px;
        margin-right: 40px;
      }

      h3 {
        font-weight: 500;
        font-size:32px;
      }

      .stars span {
        color: #f0c75c;
        font-size:30px;
        margin-right: 10px;
      }
    }

    .review-content {
      padding: 20px 0;
      font-size:28px;
      line-height: 1.5;
    }

    .review-images {
      li {
        position: relative;
        float: left;
        width: 22%;
        padding-bottom: 22%;
        margin-left: 2%;
        margin-top: 2%;
        box-sizing: border-box;
        border-radius: 2px;
        overflow: hidden;

        .img {
          position: absolute;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
